<template>
  <div class="proposal-user-info">
    <div class="proposal-user-info__header">
      <div class="proposal-user-info__header-name">
        <r-title>{{ proposal.name }}</r-title>
      </div>
      <proposal-user-info-controls
        @before-action="beforeAction"
        :proposal="proposal"
      />
      <el-button
        type="danger"
        class="r-button"
        size="mini"
        style="margin-left: auto"
        @click="beforeAction('delete')"
      >
        {{ $t("delete") }}
      </el-button>
    </div>
    <proposal-user-info-content :proposal="proposal" />
  </div>
</template>

<script>
import proposalUserInfoControls from "./components/proposal-user-info-controls";
import proposalUserInfoContent from "./components/proposal-user-info-content/proposal-user-info-content";
import { notifyFactory } from "@/utils";

export default {
  props: {
    proposal: {
      type: Object,
      required: true,
      default: () => null
    }
  },
  components: { proposalUserInfoControls, proposalUserInfoContent },
  computed: {
    isAllFieldsFilled() {
      return this.$store.state.proposal.isAllFieldsFilled;
    }
  },
  methods: {
    beforeAction(action) {
      if (action === "accept" && !this.isAllFieldsFilled) {
        const title = this.$t("accept-notify-notfilled-title");
        const message = this.$t("accept-notify-notfilled-text");
        this.$notify(notifyFactory("error", title, message));
        return;
      }

      const title = this.$t("before:title");
      const message = this.$t(`before-${action}:text`);
      const confirmButtonText = this.$t("button-confirm");
      const cancelButtonText = this.$t("button-cancel");
      this.$confirm(message, title, {
        customClass: "r-message-box",
        closeOnPressEscape: true,
        closeOnClickModal: false,
        type: "warning",
        confirmButtonText,
        cancelButtonText
      })
        .then(() => {
          this.actionHandler(action);
        })
        .catch(() => {});
    },
    actionHandler(action) {
      switch (action) {
        case "cancel":
          this.cancelChanges();
          break;
        case "accept":
          this.acceptProposal();
          break;
        case "reject":
          this.rejectProposal();
          break;
        case "delete":
          this.deleteProposal();
          break;
      }
    },
    cancelChanges() {
      this.$store.commit("SET_PROPOSAL_DISCARD_CHANGES", true);
    },
    acceptProposal() {
      this.$store.commit("SET_PROPOSAL_ACCEPT_PROPOSAL", true);
    },
    async rejectProposal() {
      this.$store.commit("SET_PROPOSAL_IS_LOADING", true);
      try {
        await this.$store.dispatch("POST_REQUEST", {
          url: `proposal?act=reject&id=${this.proposal.id}`
        });
        const title = this.$t("notify-reject-title");
        const message = this.$t("notify-reject-text");
        this.$notify(notifyFactory("error", title, message));
        this.$store.commit("SET_PROPOSAL_UPDATE", true);
        this.$store.commit("SET_PROPOSAL_IS_LOADING", false);
      } catch (e) {
        console.log(e);
        this.$store.commit("SET_PROPOSAL_IS_LOADING", false);
      }
    },
    async deleteProposal() {
      this.$store.commit("SET_PROPOSAL_IS_LOADING", true);
      try {
        await this.$store.dispatch("POST_REQUEST", {
          url: `proposal?act=delete&id=${this.proposal.id}`
        });
        const title = this.$t("notify-delete-title");
        const message = this.$t("notify-delete-text");
        this.$notify(notifyFactory("error", title, message));
        this.$store.commit("SET_PROPOSAL_UPDATE", true);
        this.$store.commit("SET_PROPOSAL_IS_LOADING", false);
      } catch (e) {
        console.log(e);
        this.$store.commit("SET_PROPOSAL_IS_LOADING", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.proposal-user-info {
  position: relative;
  &__header {
    height: 50px;
    min-height: 50px;
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid;
    border-color: var(--dividers_low_contrast) !important;
    &-name {
      max-width: calc(100% - 480px);
      margin-right: 24px;
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .r-main-title {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "delete": "Удалить",
    "notify-reject-title": "Уведомление",
    "notify-reject-text": "Заявка на демо пользователя отклонена",
    "notify-delete-title": "Уведомление",
    "notify-delete-text": "Заявка на демо пользователя удалена",
    "accept-notify-notfilled-title": "Необходимо заполнить все обязательные поля",
    "accept-notify-notfilled-text": "Заполните логин, ФИО, данные об электронной почте и Вашей компании",

    "before:title": "Предупреждение",
    "before-accept:text": "Заявка будет принята. Вы уверены?",
    "before-reject:text": "Заявка будет отклонена. Вы уверены?",
    "before-cancel:text": "Все измененные поля будут восстановлены. Вы уверены?",
    "before-delete:text": "Заявка будет удалена. Вы уверены?",
    "button-confirm": "Да",
    "button-cancel": "Отмена"
  },
  "en": {
    "delete": "Delete",
    "notify-reject-title": "Notification",
    "notify-reject-text": "Demo user proposal rejected",
    "notify-delete-title": "Notification",
    "notify-delete-text": "Demo user proposal deleted",
    "accept-notify-notfilled-title": "All required fields must be filled",
    "accept-notify-notfilled-text": "Fill in the login, full name, data about e-mail and your company",

    "before:title": "Warning",
    "before-accept:text": "Proposal will be accepted. Are you sure?",
    "before-reject:text": "Proposal will be rejected. Are you sure?",
    "before-cancel:text": "All changes will be discarded. Are you sure?",
    "before-delete:text": "Proposal will be deleted. Are you sure?",
    "button-confirm": "Yes",
    "button-cancel": "Cancel"
  }
}
</i18n>
